<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
      <!----------- 所有销售出库订单查询 -------------->
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
        <el-form-item>
          <el-date-picker v-model="order.date" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="orderisselect = true" style="width:100%"
            :unlink-panels="false"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="order.customerid" clearable filterable remote reserve-keyword :remote-method="getCustomer"
            :loading="customerLoading" placeholder="客户名称 / 简称 / 客户手机" @change="changemycustomer" style="width:100%">
            <el-option v-for="(item, index) in customerLists" :key="index" :label="item.showname"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="order.account" clearable filterable placeholder="请选支付方式" @change="orderisselect = true">
            <el-option v-for="(item, index) in accountLists" :key="index" :label="item.name" value="a0"
              v-if="item.id == 0"></el-option>
            <el-option v-for="(item, index) in accountLists" :key="index" :label="item.name" :value="item.id"
              v-if="item.id != ''"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="order.seller" clearable filterable placeholder="请选销售员" @change="orderisselect = true">
            <el-option v-for="(item, index) in sellerLists" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="order.status" clearable filterable placeholder="审核状态" @change="orderisselect = true">
            <el-option v-for="(item, index) in orderstatus" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select v-model="order.printstatus" clearable filterable placeholder="打印状态" @change="orderisselect = true">
            <el-option v-for="(item, index) in printstatuslists" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select v-model="order.manager_id" clearable placeholder="拣货人" filterable @change="orderisselect = true">
            <el-option v-for="(item, index) in sysmanagers" :label="item.truename" :value="item.id"
              :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item size="small">
          <el-select v-model="order.keytype" filterable placeholder="关键字搜索方式" @change="orderisselect = true"
            style="width:100%">
            <el-option v-for="(item, index) in keytypelists" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-input placeholder="订单号" v-model="order.key" style="width:100%" @change="orderisselect = true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" size="small" icon="el-icon-search" round @click="getOrderlists">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" size="small" icon="el-icon-printer" round @click="printmore">批量打印出库单</el-button>
        </el-form-item>
        <!-- v-if="$cookies.get('agentid') == 36 || $cookies.get('agentid') == 41 || $cookies.get('agentid') == 1 || $cookies.get('agentid') == 7"> -->
        <el-form-item v-if="['1', '7', '36', '41', '108', '188'].includes($cookies.get('agentid'))">
          <el-tooltip class="item" effect="dark" content="快递鸟打印快递电子面单" placement="top-start">
            <el-button type="warning" size="small" icon="el-icon-printer" round
              @click="shippingbirldprint">电子面单管理</el-button>
          </el-tooltip>
        </el-form-item>
        <el-form-item v-if="['1', '7', '36', '41', '108', '188'].includes($cookies.get('agentid'))">
          <el-tooltip class="item" effect="dark" content="二次分拣" placement="top-start">
            <el-button type="warning" size="small" icon="el-icon-printer" round @click="getmatchsell">拣货单</el-button>
          </el-tooltip>
        </el-form-item>
        <el-form-item v-if="['1', '7', '36', '41', '108', '188'].includes($cookies.get('agentid'))">
          <el-button type="warning" size="small" icon="el-icon-download" round @click="exportsellandlogistics">导出销售单 -
            电子面单</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" size="small" icon="el-icon-printer" round
            @click="printExpressBill">合并打印电子面单</el-button>
        </el-form-item>

      </el-form>

      <div class="backborder2" style="margin-top:10px">
        <el-table ref="multipleTable" :data="orderlists" style="width: 100%" v-loading="orderListLoading"
          @selection-change="handleSelectionChange" @row-click="selectorder">
          <el-table-column type="selection" min-width="30" align="center"></el-table-column>
          <el-table-column type="expand" min-width="100">
            <template slot-scope="props">
              <div style="padding:10px 0;">
                <div style="width:100%;color:#606266;line-height:23px;font-size:12px">
                  <span v-if="props.row.contactname != ''">收货人：{{ props.row.contactname }}，{{ props.row.phone }}，{{
                    props.row.address }}</span>
                  <span v-if="props.row.shippingcode != '' && props.row.shippingcode != null">物流单号：{{
                    props.row.shippingcode }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                  <el-button type="warning" size="small" round @click="lookshippings(props.row)"
                    v-if="$cookies.get('agentid') == 36 || $cookies.get('agentid') == 1 || $cookies.get('agentid') == 7"
                    style="margin-left:10px">查看快递信息</el-button>
                </div>
                <div style="width:100%;color:#606266;line-height:23px;font-size:12px;margin-top:5px;"
                  v-if="props.row.note != ''">
                  <span v-if="props.row.note != ''">备注：{{ props.row.note }}</span>
                </div>
                <div style="width:100%;color:#606266;line-height:23px;font-size:12px;margin-top:5px;">
                  <span>商城单号：{{ props.row.ordernumber }}</span>
                </div>
              </div>
              <el-table :data="props.row.goods">
                <el-table-column label="商品名称" min-width="250">
                  <template slot-scope="gprops">
                    <span style="float:left;width:100%;font-size:13px">{{ gprops.row.name }}</span>
                    <span style="float:left;width:100%;font-size:12px;color:#999999">编号：{{ gprops.row.number }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="sell" label="单价" min-width="120" align="center"></el-table-column>
                <el-table-column prop="discount" label="折扣（%）" min-width="120" align="center"></el-table-column>
                <el-table-column prop="dis_sell" label="折后单价" min-width="120" align="center"></el-table-column>
                <el-table-column label="数量" min-width="120" align="center">
                  <template slot-scope="nprops">
                    <span style="float:left;width:100%">{{ nprops.row.num }}
                      {{ nprops.row.unit }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="total" label="小计" min-width="120" align="center"></el-table-column>
                <el-table-column prop="type" label="类型" min-width="120" align="center">
                  <template slot-scope="gprops">
                    <span style="float:left;width:100%;font-size:13px">{{ gprops.row.type }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="id" prop="id" align="center" min-width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.id }}</span>
              <span v-if="scope.row.printnumber > 0" style="float:left;width:100%;font-size:12px">（已打印 <i
                  style="font-style:normal;font-size:14px;font-weight:bold">{{ scope.row.printnumber }}</i>
                次）</span>
            </template>
          </el-table-column>
          <el-table-column label="订单信息" min-width="240">
            <template slot-scope="scope">
              <span v-if="scope.row.paytype == 0">{{ scope.row.documents }}</span>
              <div class="sell-type-main" v-if="scope.row.paytype == 1">
                <span style="float:left">{{ scope.row.documents }}</span>
                <el-tooltip class="item" effect="dark" content="线上商城订单" placement="top-start">
                  <div class="sell-type-icon"><img src="../../assets/sellicon/sell_shop.png"></div>
                </el-tooltip>
              </div>
              <div class="sell-type-main" v-if="scope.row.paytype == 3">
                <span style="float:left">{{ scope.row.documents }}</span>
                <el-tooltip class="item" effect="dark" content="跑店订单" placement="top-start">
                  <div class="sell-type-icon"><img src="../../assets/sellicon/sell_run.png"></div>
                </el-tooltip>
              </div>
              <div class="sell-type-main" v-if="scope.row.paytype == 4">
                <span style="float:left">{{ scope.row.documents }}</span>
                <el-tooltip class="item" effect="dark" content="抽奖订单" placement="top-start">
                  <div class="sell-type-icon"><img src="../../assets/sellicon/sell_fenxiao.png"></div>
                </el-tooltip>
              </div>
              <div class="sell-type-main" v-if="scope.row.paytype == 5">
                <span style="float:left">{{ scope.row.documents }}</span>
                <el-tooltip class="item" effect="dark" content="分销订单" placement="top-start">
                  <div class="sell-type-icon"><img src="../../assets/sellicon/sell_fenxiao.png"></div>
                </el-tooltip>
              </div>
              <div class="sell-type-main" v-if="scope.row.paytype == 6">
                <span style="float:left">{{ scope.row.documents }}</span>
                <el-tooltip class="item" effect="dark" content="邀请有礼订单" placement="top-start">
                  <div class="sell-type-icon"><img src="../../assets/sellicon/sell_fenxiao.png"></div>
                </el-tooltip>
              </div>
              <div class="sell-type-main" v-if="scope.row.paytype == 7">
                <span style="float:left">{{ scope.row.documents }}</span>
                <el-tooltip class="item" effect="dark" content="抖音订单" placement="top-start">
                  <div class="sell-type-icon"><img src="../../assets/sellicon/sell_dshop.png"></div>
                </el-tooltip>
              </div>
              <div class="sell-type-main" v-if="scope.row.paytype == 8">
                <span style="float:left">{{ scope.row.documents }}</span>
                <el-tooltip class="item" effect="dark" content="天猫订单" placement="top-start">
                  <div class="sell-type-icon"><img src="../../assets/sellicon/sell_tmall.png"></div>
                </el-tooltip>
              </div>
              <div class="sell-type-main" v-if="scope.row.paytype == 9">
                <span style="float:left">{{ scope.row.documents }}</span>
                <el-tooltip class="item" effect="dark" content="拼多多订单" placement="top-start">
                  <div class="sell-type-icon"><img src="../../assets/sellicon/sell_pindd.png"></div>
                </el-tooltip>
              </div>
              <span style="float:left;width:100%;font-size:.7rem;color:#909399">客户：{{ scope.row.customername }}</span>
              <span style="float:left;width:100%;font-size:.7rem;color:#909399">销售员：{{ scope.row.clerkname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单总价" prop="total" align="center" min-width="100"></el-table-column>
          <el-table-column label="邮费" prop="express" align="center" min-width="100"></el-table-column>
          <el-table-column label="优惠金额" prop="derate" align="center" min-width="100"></el-table-column>
          <el-table-column label="应付金额" prop="real" align="center" min-width="100"></el-table-column>
          <el-table-column label="状态" min-width="120" align="center">
            <template slot-scope="scope">
              <span style="float:left;width:100%;font-size:13px" v-if="scope.row.status == 0">未审核，{{
                scope.row.accountname }}</span>
              <span style="float:left;width:100%;font-size:13px" v-if="scope.row.status == 1">已审核，{{
                scope.row.accountname }}</span>
              <span style="float:left;width:100%;font-size:13px" v-if="scope.row.status == 2">已完成，{{
                scope.row.accountname }}</span>
              <span style="float:left;width:100%;font-size:13px" v-if="scope.row.status == 3">已撤销，{{
                scope.row.accountname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单审核时间" prop="verifytime" align="center" min-width="120"></el-table-column>
          <el-table-column label="创建时间" prop="inputtime" align="center" min-width="120"></el-table-column>
          <el-table-column label="拣货人" prop="truename" align="center" min-width="100"></el-table-column>
          <el-table-column label="操作" align="center" width="300" fixed="right">
            <template slot-scope="scope">
              <el-button type="warning" size="mini" round @click="showorder(scope.row)">查看销售单</el-button>
              <el-tooltip class="item" effect="dark" content="打印电子面单" placement="top"
                v-if="(['1', '7', '36', '41', '108', '188'].includes($cookies.get('agentid'))) && scope.row.is_waybill == 0">
                <el-button v-if="scope.row.is_waybill == 0" type="warning" size="mini" round
                  @click="shippingbirldsingleprint(scope.row)">电子面单</el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="重置快递面单" placement="top"
                v-if="(['1', '7', '36', '41', '108', '188'].includes($cookies.get('agentid'))) && scope.row.is_waybill == 1">
                <el-button v-if="scope.row.is_waybill == 1" type="primary" size="mini" round
                  @click="resetWaybill(scope.row)">重置面单</el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark"
                :content="scope.row.kingdeesubmit == 1 ? '订单数据已同步至金蝶' : '将订单数据同步至金蝶'" placement="top"
                v-if="iskingdee == 1">
                <el-button :type="scope.row.kingdeesubmit == 1 ? 'warning' : ''" size="mini" round
                  @click="kingdeesellsubmit(scope.row)">金蝶同步</el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="orderPageSizeChange" @current-change="orderPageCurrentChange"
            :current-page="order.p" :page-sizes="[10, 20, 50]" :page-size="order.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="total_order_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </div>

      <!--------------------------------单个商品打印 打印信息 start ------------------------------->
      <el-dialog title="确认打印" :visible.sync="printerDialog" width="90%" top="5vh" :before-close="saveBoxData">
        <!-- 打印弹窗 -->
        <sortingBoxPrint v-if="showPrintTypeDialog" :customerName="printorderdetail.customerName" ref="printTypeRef"
          @close="showPrintTypeDialog = false" @print="printByType" />

        <div class="print-sell">
          <div style="display: inline-block;">
            <span>排序</span>
            <el-select v-model="sortType" placeholder="请选择排序方式" style="width:230px;margin-right: 20px;"
              @change="sortTypeChange">
              <el-option label="按添加商品顺序排序（默认）" value="1"></el-option>
              <el-option label="按品牌A-Z顺序排序" value="2"></el-option>
              <el-option label="按未分配分拣箱排序" value="3"></el-option>
            </el-select>
          </div>
          每页展示
          <!-- <input type="text" v-model="rollpage" v-on:blur="changepagevlaue()" class="print-sell-page" /> -->
          {{ rollpage }}

          条
          <el-button type="primary" size="mini" circle icon="el-icon-setting" style="margin-left:2%"
            @click="settingprints(printorderdetail)" />
        </div>
        <div id="printContent" v-loading="printLoading" style="overflow:hidden">
          <div v-for="(iit, i) in prpage" id="printpages">
            <span class="print-sell-page-show">{{ iit.id }}/{{ prpage.length }}</span>
            <DIV class="print-sell-page-title" align="center" v-if="printsmodel.title == 1">
              <STRONG>{{ printsmodel.titlevalue }}</STRONG>
            </DIV>
            <div class="tabletitle-container">
							<el-row :gutter="20">
								<el-col :span="8">
									<div v-if="printsmodel.customer_name==1" class="list-item left-col">客户名称：{{printorderdetail.customerName}}</div>
									<div v-if="printsmodel.deliverdate==1" class="list-item left-col">交货日期：{{printorderdetail.deliverdate}}</div>
									<div v-if="printsmodel.contactname==1" class="list-item left-col">收货人姓名：{{printorderdetail.contactname}}</div>
									<div v-if="printsmodel.contactphone==1" class="list-item left-col">收货电话：{{printorderdetail.contactphone}}</div>
								</el-col>
								<el-col :span="8">
									<div v-if="printsmodel.note==1" class="list-item center-col">出库备注：{{printorderdetail.note}} {{printorderdetail.ordernumber ? `（商城单号：${printorderdetail.ordernumber}）` : ''}}</div>
								</el-col>
								<el-col :span="8">
									<div v-if="printsmodel.documents==1" class="list-item right-col">单据编号：{{printorderdetail.documents}}</div>
									<div v-if="printsmodel.clerkname==1" class="list-item right-col">销售人员：{{printorderdetail.clerkName}}</div>
									<div v-if="printsmodel.accountname==1" class="list-item right-col">支付方式：<span>{{printorderdetail.accountName}}</span></div>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="24">
									<div v-if="printsmodel.address==1" class="list-item full-row">收货地址：{{printorderdetail.address}}</div>
								</el-col>
							</el-row>
						</div>

            <!-- ============= 分拣箱 fenjianxiang =========== -->
            <SortingBox v-show="showSortingBox" ref="sortingBox" :page="iit" :allPage="rollpage"
              :item="printorderdetail" :printsmodel="printsmodel" @change="isBoxChange = true" :sortType="sortType" />




            <!-- <TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" -->
            <table v-show="!showSortingBox" border=1 cellSpacing=0 cellPadding=1 width="100%"
              class="print-sell-page-table">
              <thead>
                <tr class="contactcontent">
                  <th v-if="printsmodel.number == 1">
                    <div align=center><b>编号</b></div>
                  </th>
                  <th v-if="printsmodel.product_name == 1" align="center" width="150px">
                    <div><b>品名</b></div>
                  </th>
                  <th v-if="printsmodel.product_spec == 1" width="80px">
                    <div align=center><b>规格</b></div>
                  </th>
                  <th v-if="printsmodel.unit == 1" width="65px">
                    <div align=center><b>单位</b></div>
                  </th>
                  <th v-if="printsmodel.num == 1" width="65px">
                    <div align=center><b>数量</b></div>
                  </th>


                  <th v-if="printsmodel.sell == 1 && currentPrintType == '1'" width="65px">
                    <div align=center><b>售价</b></div>
                  </th>
                  <th v-if="printsmodel.discount == 1 && currentPrintType == '1'" width="65px">
                    <div align=center><b>折扣</b></div>
                  </th>
                  <th v-if="printsmodel.dis_sell == 1 && currentPrintType == '1'" width="65px">
                    <div align=center><b>折后单价</b></div>
                  </th>
                  <th v-if="printsmodel.market == 1 && currentPrintType == '1'" width="65px">
                    <div align=center><b>零售价</b></div>
                  </th>
                  <th v-if="printsmodel.account == 1 && currentPrintType == '1'" width="65px">
                    <div align=center><b>小计</b></div>
                  </th>


                  <th v-if="printsmodel.warehourse == 1" width="80px">
                    <div align=center><b>仓库</b></div>
                  </th>
                  <th v-if="printsmodel.storage_location_batch == 1 && storageLocationStatus && currentPrintType == '1'" width="80px">
                    <div v-if="storageLocationStatus && !batchStatus" align=center><b>货位</b></div>
                    <div v-if="storageLocationStatus && batchStatus" align=center><b>货位/批次</b></div>
                  </th>
                  <th v-if="printsmodel.desc == 1" width="80px">
                    <div align=center><b>备注</b></div>
                  </th>
                  <th v-if="printsmodel.type == 1 && currentPrintType == '1'">
                    <div align=center><b>类型</b></div>
                  </th>
                  <th>
                    <div align=center><b>分拣箱</b></div>
                  </th>
                </tr>
              </thead>
              <tbody v-if="currentPrintType == '2' || currentPrintType == '3'">
                <tr v-for="(item, index) in printorderdetail.goods" :key="index" class="contactcontent"
                  v-if="iit.boxName == item.boxName">
                  <!-- 编号 -->
                  <td v-text="item.number" align="center" v-if="printsmodel.number == 1"></td>
                  <!-- 品名 -->
                  <td v-if="printsmodel.product_name == 1">
                    <div>{{ item.name }}</div>
                  </td>
                  <!-- 规格 -->
                  <td v-text="item.spec" align="center" v-if="printsmodel.product_spec == 1"></td>
                  <!-- 单位 -->
                  <td v-text="item.unit" align="center" v-if="printsmodel.unit == 1"></td>
                  <!-- 数量 -->
                  <td v-text="item.num" align="center" v-if="printsmodel.num == 1"></td>
                  <!-- 仓库 -->
                  <td v-text="item.warename" align="center" v-if="printsmodel.warehourse == 1"></td>
                  <!-- 备注 -->
                  <td v-text="item.desc" v-if="printsmodel.desc == 1"></td>
                  <!-- 分拣箱列 -->
                  <td v-text="item.boxName" align="center"></td>
                </tr>
              </tbody>

              <!-- 默认打印 -->
              <tbody v-else>
                <tr v-for="(item, index) in printorderdetail.goods" :key="index" class="contactcontent"
                  v-if="index >= prollpage[i]['startpage'] && index <= prollpage[i]['endpage']">
                  <!-- 编号 -->
                  <td v-text="item.number" align="center" v-if="printsmodel.number == 1"></td>
                  <!-- 品名 -->
                  <td v-if="printsmodel.product_name == 1">
                    <div>{{ item.name }}</div>
                  </td>
                  <!-- 规格 -->
                  <td v-text="item.spec" align="center" v-if="printsmodel.product_spec == 1"></td>
                  <!-- 单位 -->
                  <td v-text="item.unit" align="center" v-if="printsmodel.unit == 1"></td>
                  <!-- 数量 -->
                  <td v-text="item.num" align="center" v-if="printsmodel.num == 1"></td>
                  <!-- 售价 -->
                  <td v-text="item.sell" align="center" v-if="printsmodel.sell == 1"></td>
                  <!-- 折扣 -->
                  <td v-text="item.discount" align="center" v-if="printsmodel.discount == 1"></td>
                  <!-- 折后单价 -->
                  <td v-text="item.dis_sell" align="center" v-if="printsmodel.dis_sell == 1"></td>
                  <!-- 零售价 -->
                  <td v-text="item.market" align="center" v-if="printsmodel.market == 1"></td>
                  <!-- 小计 -->
                  <td v-text="item.total" align="center" v-if="printsmodel.account == 1"></td>
                  <!-- 仓库 -->
                  <td align="center" v-if="printsmodel.warehourse == 1" width="180">
                    <div>{{ item.warename }}</div>
                    <div v-for="lc in item.storage_location" :key="lc.full_code">{{ lc.full_code }}（{{ lc.numbers }}）
                    </div>
                  </td>

                  <!-- 只开了货位的情况 【货位】 -->
                  <td align="center" v-if="storageLocationStatus && !batchStatus && printsmodel.storage_location_batch == 1" width="180">
                    <div>
                      <div v-for="btchItem in item.batch_info" :key="item.storage_location_id">
                        <div>
                          {{ btchItem.full_code }}
                          <span style="color: #909399;">
                            [<span style="color: #F56C6C;">{{ btchItem.total }}</span>]
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                  

                  <!-- 批次/货位都开启的情况  【货位/批次】 -->
                  <td align="center" v-if="storageLocationStatus && batchStatus && printsmodel.storage_location_batch == 1" width="180">
                    <div>
                      <div v-for="btchItem in item.batch_info" :key="item.storage_location_id">
                        <div>
                          {{ btchItem.full_code }}
                          <span v-if="!batchStatus" style="color: #909399;">
                            [<span style="color: #F56C6C;">{{ btchItem.total }}</span>]
                          </span>
                        </div>

                        <div v-if="batchStatus">
                          <div style="color: #909399;" v-for="batch in btchItem.child"
                            :key="batch.batch_storage_inventory_id">
                            {{ batch.batch_sn }}
                            <span v-if="batch.start_date && batch.end_date">
                              [<span style="color: #F56C6C;">{{ batch.start_date }}至{{ batch.end_date }}</span>]
                            </span>
                            [<span style="color: #F56C6C;">{{ batch.numbers }}</span>]
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <!-- 批次/货位 -->

                  <!-- 备注 -->
                  <td v-text="item.desc" align="center" v-if="printsmodel.desc == 1"
                    style="word-wrap: break-word; word-break: break-all;">
                  </td>
                  <!-- 类型 -->
                  <td v-text="item.showtype" align="center" v-if="printsmodel.type == 1"></td>

                  <!-- 分拣箱列 -->
                  <td v-text="(item.box.map(box => box.box_name)).join(',')" align="center"></td>
                </tr>
              </tbody>

            </table>

            <table id="footerInfo" border=0 cellSpacing=0 cellPadding=0 width="100%">
              <tbody>
                <tr class="top1">
                  <td v-if="printsmodel.inputdate == 1"><span>录单日期：{{ printorderdetail.inputdate }}</span></td>
                  <td v-if="printsmodel.person_who_records == 1"><span>录单人：{{ printorderdetail.sysmanagername }}</span>
                  </td>
                  <td v-if="printsmodel.verifytime == 1"><span>审核时间：{{ printorderdetail.verifytime }}</span></td>
                  <td v-if="printorderdetail.verifyername != ''"><span>审核人：{{ printorderdetail.verifyername }}</span>
                  </td>
                </tr>
                <tr class="top1">
                  <td v-if="printsmodel.pick_manager_name == 1"><span>拣货人：{{ printorderdetail.pick_manager_name
                      }}</span></td>
                  <td v-if="printsmodel.pick_finish_time == 1"><span>拣货完成时间：{{ printorderdetail.pick_finish_time
                      }}</span>
                  </td>
                  <td v-if="printsmodel.sysmanagername == 1"><span>操作人：{{ printorderdetail.sysmanagername }}</span></td>
                  <td v-if="printsmodel.finishtime == 1"><span>完成时间：{{ printorderdetail.finishtime }}</span></td>
                </tr>
                <tr class="top1">
                  <td v-if="printsmodel.total == 1"><span>应付金额：{{ printorderdetail.real }} 元</span></td>
                  <td v-if="printsmodel.isexpress == 1"><span>快递费用：{{ printorderdetail.express }} 元</span>
                  </td>
                  <td v-if="printsmodel.derate == 1"><span>优惠金额：{{ printorderdetail.derate }} 元</span>
                  </td>
                  <td v-if="printsmodel.isdriver == 1"><span>是否司机收款：{{ printorderdetail.isdriver == 0 ? '否'
                    :
                    '是' }}</span></td>
                </tr>
                <tr class="top1" v-if="printsmodel.print == 1"">
						            <td :colspan="4"><span>{{ printsmodel.printvalue }}</span></td>
                </tr>
                <tr class="top2">
                  <td><span v-if="printsmodel.p_man == 1">打包人：{{ printorderdetail.packager_name }}</span></td>
                  <td><span v-if="printsmodel.s_man == 1">送货人</span></td>
                  <td><span v-if="printsmodel.ss_man == 1">收货人</span></td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
              </TBODY>
            </TABLE>
            <div class="pageBreak"></div>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <div style="display: inline-block;margin-right: 10px;" v-if="goodsLocationStatus">
            <el-checkbox :true-label=1 :false-label=0 v-model="pick" />
            <span style="color: #606266;font-size: 14px;">按拣货单出库</span>
          </div>
          <el-button size="medium" @click="printerDialog = false">取 消</el-button>
          <el-button size="medium" :loading="boxLoading" @click="saveBoxData">保存数据</el-button>
          <el-button size="medium" type="primary" @click="showPrintTypeDialogFn" :loading="printorderLoading"
            v-if="actionauth.order_print == 'true'">打印销售单</el-button>
          <el-button size="medium" type="danger" @click="cannelorder" :loading="cannelLoading"
            v-if="printorderdetail.status == 1 && actionauth.order_cannel == 'true'">撤销销售单</el-button>
          <el-button size="medium" type="danger" @click="finishorder" :loading="finishLoading"
            v-if="printorderdetail.status == 1 && actionauth.order_finished == 'true'">完成销售单</el-button>
          <el-button size="medium" type="danger" @click="cannelfinish" :loading="cannelfinishLoading"
            v-if="printorderdetail.status == 2 && actionauth.order_finished_cannel == 'true'">撤销完成</el-button>
          <el-button size="medium" type="primary" @click="exportorder" >导出</el-button>
        </div>
      </el-dialog>
      <!-------------------------------- 单个商品打印 打印信息 end--------------------------->

      <!--------------------------------批量打印订单信息 end--------------------------->
      <el-dialog title="订单批量打印" :visible.sync="printermoreDialog" width="80%" top="5vh">
        <div style="width:100%;text-align:right">
          每页展示 <input type="text" v-model="rollpage" v-on:blur="changeprintorders()"
            style="border-radius:5px;border:1px solid rgb(192, 196, 204);background-color:#fff;color:#606266;width:25px;height:30px;line-height:40px;padding:0 15px;margin-bottom:20px" />
          条
        </div>
        <div id="printmoreContent" v-loading="printermoreLoading">
          <div v-for="(item, i) in orderprints">
            <span style="float:right">{{ item.localpage }}/{{ item.allpage }}</span>
            <DIV style="font-size:13px;padding-bottom:2px;margin-bottom:0" align="center" v-if="printsmodel.title == 1">
              <STRONG>{{ printsmodel.titlevalue }}</STRONG>
            </DIV>
            <ul class="titlelists">
              <li v-if="printsmodel.customer_name == 1">客户名称：{{ item.customerName }}</li>
              <li v-if="printsmodel.deliverdate == 1">交货日期：{{ item.deliverdate }}</li>
              <li v-if="printsmodel.contactname == 1">收货人姓名：{{ item.receive_name }}</li>
              <li v-if="printsmodel.documents == 1">单据编号：{{ item.documents }}</li>
              <li v-if="printsmodel.note == 1">出库备注：{{ item.note }}</li>
              <li v-if="printsmodel.contactphone == 1">收货电话：{{ item.receive_phone }}</li>
              <li v-if="printsmodel.clerkname == 1">销售人员：{{ item.clerkName }}</li>
              <li v-if="printsmodel.accountname == 1">支付方式：<span>{{ item.accountName }}</span></li>
              <li v-if="printsmodel.address == 1" style="width:100%">收货地址：{{ item.receive_address }}</li>
            </ul>



            <TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse;font-size:13px"
              bordercolor="#333333">
              <TR class="contactcontent">
                <TD v-if="printsmodel.number == 1">
                  <DIV align=center><b>编号</b></DIV>
                </TD>
                <TD v-if="printsmodel.product_name == 1">
                  <DIV align=center><b>品名</b></DIV>
                </TD>
                <TD v-if="printsmodel.product_spec == 1">
                  <DIV align=center><b>规格</b></DIV>
                </TD>
                <TD v-if="printsmodel.unit == 1">
                  <DIV align=center><b>单位</b></DIV>
                </TD>
                <TD v-if="printsmodel.num == 1">
                  <DIV align=center><b>数量</b></DIV>
                </TD>
                <TD v-if="printsmodel.sell == 1">
                  <DIV align=center><b>售价</b></DIV>
                </TD>
                <TD v-if="printsmodel.discount == 1">
                  <DIV align=center><b>折扣</b></DIV>
                </TD>
                <TD v-if="printsmodel.dis_sell == 1">
                  <DIV align=center><b>折后单价</b></DIV>
                </TD>
                <TD v-if="printsmodel.market == 1">
                  <DIV align=center><b>零售价</b></DIV>
                </TD>
                <TD v-if="printsmodel.account == 1">
                  <DIV align=center><b>小计</b></DIV>
                </TD>
                <TD v-if="printsmodel.warehourse == 1">
                  <DIV align=center><b>仓库</b></DIV>
                </TD>
                <TD v-if="printsmodel.desc == 1">
                  <DIV align=center><b>备注</b></DIV>
                </TD>
                <TD v-if="printsmodel.type == 1">
                  <DIV align=center><b>类型</b></DIV>
                </TD>
              </TR>
              <TR v-for="(goods, index) in item.goods" :key="index" class="contactcontent">
                <TD v-text="goods.number" align="center" v-if="printsmodel.number == 1"></TD>
                <TD style="padding-left:1%" v-if="printsmodel.product_name == 1">
                  <div style="float:left;width:100%;" @click="">{{ goods.name }}</div>
                </TD>
                <TD v-text="goods.spec" style="padding-left:1%" v-if="printsmodel.product_spec == 1"></TD>
                <TD v-text="goods.unit" align="center" v-if="printsmodel.unit == 1"></TD>
                <TD v-text="goods.num" align="center" v-if="printsmodel.num == 1"></TD>
                <TD v-text="goods.sell" align="center" v-if="printsmodel.sell == 1"></TD>
                <TD v-text="goods.discount" align="center" v-if="printsmodel.discount == 1"></TD>
                <TD v-text="goods.dis_sell" align="center" v-if="printsmodel.dis_sell == 1"></TD>
                <TD v-text="goods.market" align="center" v-if="printsmodel.market == 1"></TD>
                <TD v-text="goods.total" align="center" v-if="printsmodel.account == 1"></TD>
                <TD v-text="goods.warename" align="center" v-if="printsmodel.warehourse == 1"></TD>
                <TD v-text="goods.desc" style="padding-left:1%" v-if="printsmodel.desc == 1"></TD>
                <TD v-text="goods.showtype" align="center" v-if="printsmodel.type == 1"></TD>
              </TR>
              <TR v-if="item.total != ''">

                <TD align="center" v-if="printsmodel.number == 1 || printsmodel.product_name == 1"><b>合计</b>
                </TD>
                <TD v-if="printsmodel.number == 1 && printsmodel.product_name == 1"></TD>
                <TD v-if="printsmodel.product_spec == 1"></TD>
                <TD v-if="printsmodel.unit == 1">&nbsp;</TD>
                <TD v-if="printsmodel.num == 1" align="center">{{ item.allnumber }}</TD>
                <TD v-if="printsmodel.sell == 1">&nbsp;</TD>
                <TD v-if="printsmodel.discount == 1">&nbsp;</TD>
                <TD v-if="printsmodel.dis_sell == 1">&nbsp;</TD>
                <TD v-if="printsmodel.market == 1">&nbsp;</TD>
                <TD align="center" v-if="printsmodel.account == 1">{{ item.total }}</TD>
                <TD v-if="printsmodel.warehourse == 1">&nbsp;</TD>
                <TD v-if="printsmodel.desc == 1">&nbsp;</TD>
                <TD v-if="printsmodel.type == 1">&nbsp;</TD>
              </TR>
            </table>
            <TABLE border=0 cellSpacing=0 cellPadding=0 width="100%">
              <TBODY>
                <TR class="top1">
                  <TD v-if="printsmodel.inputdate == 1"><span>录单日期：{{ item.inputdate }}</span></TD>
                  <TD v-if="item.verifyername != ''"><span>审核人：{{ item.verifyername }}</span></TD>
                  <TD v-if="printsmodel.sysmanagername == 1"><span>操作人：{{ item.sysmanagername }}</span>
                  </TD>
                </TR>
                <TR class="top1">
                  <TD v-if="printsmodel.total == 1"><span>应付金额：{{ item.real }} 元</span></TD>
                  <TD v-if="printorderdetail.express > 0"><span>快递费用：{{ item.express }} 元</span></TD>
                  <TD v-if="printsmodel.derate == 1"><span>优惠金额：{{ item.derate }} 元</span></TD>
                </TR>
                <TR class="top1" v-if="printsmodel.print == 1"">
						            <TD :colspan="4"><span>{{ printsmodel.printvalue }}</span></TD>
                </tr>
                <TR class="top2">
                  <TD><span v-if="printsmodel.p_man == 1">打包人</span></TD>
                  <TD><span v-if="printsmodel.s_man == 1">送货人</span></TD>
                  <TD><span v-if="printsmodel.ss_man == 1">收货人</span></TD>
                  <TD>&nbsp;</TD>
                  <TD>&nbsp;</TD>
                </tr>
              </TBODY>
            </TABLE>
            <div class="pageBreak"></div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="printermoreDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" @click="goprintmore" :loading="printorderLoading"
            v-if="actionauth.order_print == 'true'">批量打印销售单</el-button>
        </div>
      </el-dialog>

      <!-- 设置快递、物流信息 -->
      <el-dialog title="设置快递信息" :visible.sync="setexpressDialog" width="75%" top="10vh">
        <div
          style="float:left;width:100%;line-height:1.2rem;border-bottom:1px solid rgb(221,221,221,.6);padding-bottom:.3rem">
          <el-button type="danger" icon="el-icon-plus" circle size="mini" @click="addexpress"
            style="float:right"></el-button>
        </div>
        <el-table :data="expresslists" v-loading="expressloading">
          <el-table-column label="快递" align="center">
            <template slot-scope="scope" v-if="expresslists[scope.$index].status != 'del'">
              <el-select v-model="expresslists[scope.$index].expressid" filterable clearable placeholder="请选择快递"
                size="small">
                <el-option v-for="(item, index) in allexpress" :label="item.name" :value="item.id"
                  :key="index"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="物流单号" align="center">
            <template slot-scope="scope" v-if="expresslists[scope.$index].status != 'del'">
              <el-input type="text" v-model="expresslists[scope.$index].expresscode" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="重量（kg）" align="center">
            <template slot-scope="scope" v-if="expresslists[scope.$index].status != 'del'">
              <el-input type="text" v-model="expresslists[scope.$index].weight" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="价格（元）" align="center">
            <template slot-scope="scope" v-if="expresslists[scope.$index].status != 'del'">
              <el-input type="text" v-model="expresslists[scope.$index].price" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="时间" align="center">
            <template slot-scope="scope" v-if="expresslists[scope.$index].status != 'del'">
              <el-date-picker v-model="expresslists[scope.$index].sendtime" type="date" placeholder="开始日期"
                format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope" v-if="expresslists[scope.$index].status != 'del'">
              <el-button type="danger" icon="el-icon-delete" circle size="mini"
                @click="delexpress(scope.$index)"></el-button>
            </template>
          </el-table-column>
        </el-table>

        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="setexpressDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="updateLoading" @click="saveexpress">保
            存</el-button>
        </div>
      </el-dialog>


      <div v-if="printsettingDialog" class="printsetting">
        <div class="printmain" :style="printclass">
          <div class="printin" v-loading="printmadequery.loading">
            <div slot="footer" class="dialog-footer" style="float:right">
              <el-button size="mini" @click="closeprinters">取 消</el-button>
              <el-button size="mini" type="primary" @click="saveprintmade">保 存</el-button>
            </div>

            <el-form :inline="true" class="demo-form-inline" size="small"
              style="float:left;width:100%;margin-top:30px;">
              <el-form-item>
                <div style="width:100%;font-size:13px;font-weight:450;line-height:23px">
                  打印模板设置（客户：{{ printmadequery.customername != '' ? printmadequery.customername : '散客' }}）
                </div>
              </el-form-item>
              <template v-for="(item, index) in printmadequery.data">
                <el-form-item label="主体名称" label-width="120" style="float:left;width:100%" v-if="item.id == 83">
                  <el-checkbox v-model="item.isshow" />
                  <el-input type="text" size="small" v-model="item.value" placeholder="请输入打印主体"
                    style="width:85%;margin-left:5%" />
                </el-form-item>
                <el-form-item label="默认设置" label-width="120" style="float:left;width:100%" v-if="item.id == 14">
                  <el-checkbox v-model="item.isshow" />
                  <el-input type="text" size="small" v-model="item.value" placeholder="请输入默认显示设置内容"
                    style="width:85%;margin-left:5%" />
                </el-form-item>
                <el-form-item label="每页条数" label-width="120" style="float:left;width:100%" v-if="item.id == 88">
                  <el-checkbox v-model="item.isshow" />
                  <el-input type="text" size="small" v-model="item.value" placeholder="请输入每页条数"
                    style="width:85%;margin-left:5%" />
                </el-form-item>
                <el-form-item label="客户名称" label-width="120" style="float:left;width:45%" v-if="item.id == 1">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="交货日期" label-width="120" style="float:left;width:45%" v-if="item.id == 2">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="单据编号" label-width="120" style="float:left;width:45%" v-if="item.id == 3">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="支付方式" label-width="120" style="float:left;width:45%" v-if="item.id == 4">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="销售人员" label-width="120" style="float:left;width:45%" v-if="item.id == 5">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="出库备注" label-width="120" style="float:left;width:45%" v-if="item.id == 6">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="收货姓名" label-width="120" style="float:left;width:45%" v-if="item.id == 7">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="收货电话" label-width="120" style="float:left;width:45%" v-if="item.id == 8">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="收货地址" label-width="120" style="float:left;width:45%" v-if="item.id == 9">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="录单日期" label-width="120" style="float:left;width:45%" v-if="item.id == 10">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="优惠金额" label-width="120" style="float:left;width:45%" v-if="item.id == 11">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="实付金额" label-width="120" style="float:left;width:45%" v-if="item.id == 12">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="操作人员" label-width="120" style="float:left;width:45%" v-if="item.id == 13">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="打包人员" label-width="120" style="float:left;width:45%" v-if="item.id == 15">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="送货人员" label-width="120" style="float:left;width:45%" v-if="item.id == 16">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="收货人员" label-width="120" style="float:left;width:45%" v-if="item.id == 87">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="司机收款" label-width="120" style="float:left;width:45%" v-if="item.id == 135">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="快递费用" label-width="120" style="float:left;width:45%" v-if="item.id == 136">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="订单备注" label-width="120" style="float:left;width:45%" v-if="item.id == 27">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="录单人" label-width="120" style="float:left;width:45%" v-if="item.id == 137">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="审核时间" label-width="120" style="float:left;width:45%" v-if="item.id == 138">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="拣货人" label-width="120" style="float:left;width:45%" v-if="item.id == 139">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="拣货完成时间" label-width="120" style="float:left;width:45%" v-if="item.id == 140">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="操作完成时间" label-width="120" v-if="item.id == 141"
                  style="float:left;width:90%;padding-bottom:10px;border-bottom:1px dashed #666666">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>

                <el-form-item label="商品编号" label-width="120" style="float:left;width:45%" v-if="item.id == 17">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品名称" label-width="120" style="float:left;width:45%" v-if="item.id == 18">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品规格" label-width="120" style="float:left;width:45%" v-if="item.id == 80">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品单位" label-width="120" style="float:left;width:45%" v-if="item.id == 19">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品数量" label-width="120" style="float:left;width:45%" v-if="item.id == 20">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品售价" label-width="120" style="float:left;width:45%" v-if="item.id == 21">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品折扣" label-width="120" style="float:left;width:45%" v-if="item.id == 22">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="折后单价" label-width="120" style="float:left;width:45%" v-if="item.id == 23">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="零售价格" label-width="120" style="float:left;width:45%" v-if="item.id == 24">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品小计" label-width="120" style="float:left;width:45%" v-if="item.id == 25">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="出库仓库" label-width="120" style="float:left;width:45%" v-if="item.id == 26">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item v-if="storageLocationStatus && batchStatus && item.id == 159" label="货位/批次" label-width="120" style="float:left;width:45%">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item v-if="storageLocationStatus && !batchStatus && item.id == 159" label="货位" label-width="120" style="float:left;width:45%">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品类型" label-width="120" style="float:left;width:45%" v-if="item.id == 79">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
              </template>
            </el-form>

          </div>
        </div>
      </div>



      <!-- 查看快递信息 -->
      <el-dialog title="查看快递信息" :visible.sync="myshippingDialog" top="10vh" width="70%" height="100%"
        :beforeClose="closemyshipping">
        <Showshipping v-model="myorderid" :ordertype="myordertype" @finish="closemyshippingDialog" />
        <div slot="footer" class="dialog-footer" style="text-align:right;margin-top:20px">
          <el-button size="small" @click="myshippingDialog = false">取 消</el-button>
        </div>
      </el-dialog>


      <printerExpress ref="printerExpressRef" @close="getOrderlists" />

    </div>
  </transition>
</template>

<script>
import Showshipping from '@/components/mall/shipping/showshipping' //查看快递信息
import SortingBox from './SortingBox.vue';
import sortingBoxPrint from './sortingBoxPrint.vue';
import printerExpress from './print/printerExpress.vue';
export default {
  components: { Showshipping, SortingBox, sortingBoxPrint, printerExpress },
  data() {
    return {
      showSortingBox: true,
      url: this.GLOBAL.domain + "Sell/index",
      datacenter: this.$cookies.get('datacenter'),
      transitionshow: true,
      actionauth: '',
      lists: [],
      addandeditsellDialog: false,
      listLoading: false,
      search: {
        act: 'barcode',
        token: this.$cookies.get('token'),
        key: '',
        customer: ''
      },
      query: {
        act: 'lists',
        token: this.$cookies.get('token'),
        customerid: '',
        searchcustomerid: 1,
        rollpage: 1000, // 页大小
        p: 1
      },
      total_rows: 0,
      customerLists: [],
      wareHouseLists: [],
      accountLists: [],
      nums: [],
      sells: [],
      discounts: [],
      disells: [],
      totals: [],
      warehouses: [],
      categorylist: [],
      desc: [],
      create: {
        act: 'add',
        token: this.$cookies.get('token'),
        deliverdate: new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
        id: '',
        account: '',
        documents: '',
        note: '',
        total: 0.00,
        derate: 0.00,
        express: 0.00,
        seller: '',
        customer: '',
        verifyer: '',
        sysmanager: '',
        shipping: '',
        shippingcode: '',
        status: 0,
      },
      unitLoading: false,
      unitDialog: false,
      showprinterDialog: false,
      unitlists: [],
      unitListLoading: false,
      changeunitid: 0,
      addDialog: false,
      addListLoading: false,
      productquery: {
        act: 'inventory',
        token: this.$cookies.get('token'),
        brandid: '',
        catid: '',
        warehouse: '',
        customerid: '',
        key: '',
        rollpage: 10, // 页大小
        p: 1
      },
      productlists: [],
      brandlists: [],
      total_product_rows: 0,
      addProductLoading: false,
      multipleSelection: [],
      customerLoading: false,
      sellerLists: [],
      wareDialog: false,
      wareListLoading: false,
      accountName: '未支付',
      customerName: '',
      contactname: '',
      contactphone: '',
      sysmanagername: '',
      address: '',
      printdesc: '',
      totalprice: 0.00,
      printerDialog: false,
      clerkName: '',
      isshowtype: 0,
      inputdate: new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      typeDialog: false,
      typearr: [
        { name: '消费' },
        { name: '赠送' },
        { name: '自用' },
        { name: '报废' },
        { name: '欠货' }
      ],
      shippings: [
        { id: '1', name: '线下配送' },
        { id: '2', name: '物流' },
        { id: '3', name: '快递' },
        { id: '4', name: '自提' }
      ],

      printsmodel: [],

      prpage: [],
      prollpage: [],
      prtotal: 0,
      rollpage: '',
      allprintpage: '',
      defaultwarehouseid: '', //默认发货仓库

      order: {
        act: 'getfavorderlists',
        date: '',
        manager_id: '',
        customerid: '',
        customername: '',
        seller: '',
        status: '',
        orderlevel: 1,
        key: '',
        keytype: 1,
        account: '',
        printstatus: '',
        token: this.$cookies.get('token'),
        p: 1,
        rollpage: 10
      },
      keytypelists: [{ id: 1, name: '按订单号' }, { id: 2, name: '按商品名称 / 编号 / 条形码' }],
      printstatuslists: [{ id: 1, name: '已打印销售出库单' }, { id: 2, name: '未打印销售出库单' }],
      total_order_rows: 0,
      orderstatus: [
        { id: 0, name: '未审核' },
        { id: 1, name: '已审核，未出库' },
        { id: 2, name: '已完成' },
        { id: 3, name: '已撤销' },
      ],
      orderstatus: [
        { id: 1, name: '已审核' },
        { id: 2, name: '已完成' },
      ],
      orderlists: [],
      orderListLoading: false,
      orderaddLoading: false,
      suresellLoading: false,
      sellverifyLoading: false,
      selldelLoading: false,
      printorderdetail: [],
      printLoading: false,
      printorderLoading: false,
      cannelLoading: false,
      finishLoading: false,
      orderisselect: false,
      orderlistsstatus: [],
      orderselectids: [],
      printermoreDialog: false,
      printermoreLoading: false,
      printmorelists: [],
      orderprints: [],
      cannelfinishLoading: false,
      expresslists: [],
      allexpress: [],
      setexpressDialog: false,
      expressloading: false,
      saveexpresssellid: '',
      updateLoading: false,
      iskingdee: 0,
      printwidth: 0,

      printsettingDialog: false,
      printclass: {
        'margin-right': '-20%',
      },

      printmadequery: {
        act: 'saveprintmade',
        id: '',
        customername: '',
        loading: '',
        data: [],
      },

      myshippingDialog: false,
      myorderid: '',
      myordertype: '',
      boxLoading: false,
      isBoxChange: false,
      sortType: '1',
      showPrintTypeDialog: false,
      currentPrintType: '1',
      pick: 1,
      goodsLocationStatus: false,
      batchStatus: false,
      storageLocationStatus: false,
      sysmanagers: [],
    }
  },
  mounted() {
    this.getactionauth(); //获取权限设置
    this.getWarehouse();  //仓库列表
    this.getAccount(); //支付账号列表
    this.getSeller(); //获取销售员列表
    this.getSysmanager(); //获取操作人列表
    this.getPrintdesc(); //获取默认打印信息
    this.getCategoryList(); //获取分类列表
    //this.getprintsmodel(); //获取打印显示模板信息
    this.getdefaultwarehouse(); //获取默认发货仓库
    this.getallexpress(); //获取快递信息列表  
    this.checkiskingdee(); //查看当前代理商是否开启金蝶权限 
    this.getOrderlists(); //获取销售订单列表
    this.checkLocationStatus()
    this.getSysmanager()
    this.batchStatus = localStorage.getItem('batchStatus') == 'true'
    this.storageLocationStatus = localStorage.getItem('storageLocationStatus') == 'true'
  },


  methods: {
    /** 获取拣货人 **/
    getSysmanager() {
      var resource = this.$resource(this.GLOBAL.domain + "Manager/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000, p: 1 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.sysmanagers = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },
    sortTypeChange(sortType) {
      this.$refs.sortingBox.forEach(ref => {
        ref.sortTableData(sortType)
      })

    },
    saveBoxData(done) {
      this.boxLoading = true
      // const data = this.$refs.sortingBox.getBoxData()
      let data = []
      this.$refs.sortingBox.forEach(res => {
        data = [...data, ...res.getBoxData()]
      })
      if (done && typeof done === 'function') {
        done()
      }
      // 保存分拣箱
      var resource = this.$resource(this.url);
      resource.save({ act: 'save_sorting_box', token: this.$cookies.get('token'), params: JSON.stringify(data) })
        .then((res) => {
          this.boxLoading = false
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.isBoxChange = false
            this.$message.success('分拣箱已保存')
          }
        })
    },
    handleTableCheckbox(val, row) {
      row.checked = val
      this.$set(row, 'checked', val)
    },

    /** 导出销售单-电子面单 **/
    exportsellandlogistics() {
      if (this.order.date.length == 0) { this.$message.error('请选择要导出的时间'); return false; }

      var url = this.GLOBAL.exportUrl + 'Sell/index/act/exportsellandlogistics/token/' + this.$cookies.get('token');
      url += '/starttime/' + this.order.date[0];
      url += '/endtime/' + this.order.date[1];
      if (this.order.customerid > 0) url += '/customerid/' + this.order.customerid;
      if (this.order.account > 0) url += '/account/' + this.order.account;
      if (this.order.seller > 0) url += '/seller/' + this.order.seller;
      if (this.order.status > 0) url += '/status/' + this.order.status;
      if (this.order.printstatus > 0) url += '/printstatus/' + this.order.printstatus;
      if (this.order.keytype > 0) url += '/keytype/' + this.order.keytype;
      url += '/key/' + this.order.key;

      location.href = url;
    },


    /** 二次分拣 **/
    getmatchsell() {
      this.$emit('listenchild', { name: '二次分拣', url: 'sellprint', data: {} });
    },

    /** 批量打印电子面单 */
    printExpressBill() {
      if (this.orderselectids.length == 0) { this.$message.error("请点击订单号左边方框选择需要打印的订单信息"); return false; }
      const dataArr = []
      this.orderlists.forEach(item => {
        if (this.orderselectids.indexOf(item.id) > -1) {
          dataArr.push(item)
        }
      })
      if (dataArr.length > 0) {
        // 判断dataArr中每个数据的address、contactname、phone是否都一致
        const isConsistent = dataArr.every((item, index, array) => {
          if (index === 0) return true; // 第一个元素不需要比较
          return item.address === array[0].address &&
            item.contactname === array[0].contactname &&
            item.phone === array[0].phone;
        });
        const haveWaybill = dataArr.some(item => item.is_waybill == 1)
        if (!isConsistent) {
          this.$message.error("收货信息不一致，无法合并打印电子面单！")
        } else if (haveWaybill) {
          this.$message.error("所选销售单已有快递记录，请选择未生成快递记录的销售单！")
        } else {
          this.$refs.printerExpressRef.openDialog(dataArr)
        }

      }

    },

    /** 查看当前代理商是否开启了金蝶权限 **/
    checkiskingdee() {
      var resource = this.$resource(this.GLOBAL.domain + "kingdee/index");
      resource.save({ act: 'isopenkingdee', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.iskingdee = result.iskingdee;
        }
      }).catch((res) => {

      });
    },

    /** 保存快递信息 **/
    saveexpress() {
      this.expressloading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'saveexpress', id: this.saveexpresssellid, data: this.expresslists, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.expressloading = false;
        } else {
          this.expressloading = false;
          this.setexpressDialog = false;
        }
      }).catch((res) => {
        this.expressloading = false;
      });
    },

    /** 新增快递信息 **/
    addexpress() {
      this.expresslists.push({ id: '', expressid: '', expresscode: '', weight: '', price: '', sendtime: '', status: 'add' });
    },

    /** 删除快递信息 **/
    delexpress(index) {
      if (this.expresslists[index].id > 0) {
        this.expresslists[index].status = 'del';
      } else {
        this.expresslists.splice(index, 1);
      }
    },

    /** 设置快递信息 **/
    getexpress(item) {
      this.expresslists = [];
      this.saveexpresssellid = item.id;
      this.setexpressDialog = true;
      this.expressloading = true;
      var resource = this.$resource(this.url);
      resource.query({ act: 'getexpress', id: item.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.expressloading = false;
        } else {
          this.expresslists = JSON.parse(Base64.decode(res.data.Data));
          this.expressloading = false;
        }
      }).catch((res) => {
        this.expressloading = false;
      });
    },

    /** 获取所有的快递信息 **/
    getallexpress() {
      var resource = this.$resource(this.GLOBAL.domain + "Express/index");
      resource.query({ act: 'ordersellslists', token: this.$cookies.get('token'), p: 1, rollpage: 10000000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
        } else {
          this.allexpress = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {

      });
    },

    /** 重置表单 **/
    reset() {
      this.$refs.create.resetFields();
      this.create.derate = '0.00';
      this.setDocuments();
      this.search.customer = '';
    },


    /** 获取操作功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },


    //获取订单信息列表
    getOrderlists() {
      if (this.orderisselect == true) {
        this.order.p = 1;
        this.order.rollpage = 10;
      }

      this.orderListLoading = true;
      var resource = this.$resource(this.url);
      resource.save(this.order).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.orderListLoading = false;
        } else {
          this.orderlists = JSON.parse(Base64.decode(res.data.Data));
          this.total_order_rows = parseInt(res.data.count);
          this.orderListLoading = false;
          if (this.orderisselect == true) this.orderisselect = false;

          //清空选中的订单,并往里写入如选中订单状态为未选中
          var _this = this;
          this.orderlistsstatus = [];
          this.orderselectids = [];
          this.orderlists.forEach(function (item, i) {
            _this.orderlistsstatus.push(0);
          });


          //打印完成刷新页面时重新加载参数
          if (this.$cookies.get('print_back_data_sellorder') && this.$cookies.get('print_back_data_sellorder') != '') {
            var data = this.$cookies.get('print_back_data_sellorder');
            data = JSON.parse(data);
            this.orderisselect = data.orderisselect;
            this.order = data.order;
            this.$cookies.set('print_back_data_sellorder', '');
            this.getCustomer(this.order.customername);
            this.getOrderlists(); //获取销售订单列表
          }


        }
      }).catch((res) => {
        this.orderListLoading = false;
      });
    },

    orderPageSizeChange(val) {
      this.order.rollpage = val;
      this.getOrderlists();
    },
    orderPageCurrentChange(val) {
      this.order.p = val;
      this.getOrderlists();
    },

    /** 获取客户 **/
    getCustomer(query) {
      if (query !== '') {
        this.customerLoading = true;
        var resource = this.$resource(this.GLOBAL.domain + "Customer/index");
        resource.query({ act: 'lists', key: query, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.customerLoading = false;
          } else {
            this.customerLists = JSON.parse(Base64.decode(res.data.Data));
            this.customerLoading = false;
          }
        }).catch((res) => {
          //this.$message.error(this.GLOBAL.errortext);
          this.customerLoading = false;
        });
      }
    },

    changemycustomer(val) {
      var customername = '';
      this.customerLists.forEach(function (item, i) {
        if (val == item.id) customername = item.name;
      });
      this.order.customername = customername;
      this.orderisselect = true;
    },


    /** 获取仓库 **/
    getWarehouse() {
      var resource = this.$resource(this.GLOBAL.domain + "Ware/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },
    /** 重置面单 */
    resetWaybill(row) {
      // 提示
      this.$confirm('是否重置销售单的所有快递面单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          url: this.GLOBAL.domain + "Sellshippingbirld/index",
          method: 'POST',
          data: {
            act: 'reset_waybill',
            id: row.id
          }
        })
          .then(res => {
            if (res.Result == 0) {
              this.$message({
                type: 'success',
                message: '重置成功!'
              });
              this.getOrderlists()
            }
          });
      });
    },


    /** 获取销售员 **/
    getSeller() {
      var resource = this.$resource(this.GLOBAL.domain + "Clerk/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.sellerLists = JSON.parse(Base64.decode(res.data.Data));
          //默认选择第一个销售员
          if (this.sellerLists != '') this.create.seller = this.sellerLists[0]['id'];
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 获取经手人 **/
    getSysmanager() {
      var resource = this.$resource(this.GLOBAL.domain + "Manager/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000, p: 1 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.sysmanagers = JSON.parse(Base64.decode(res.data.Data));
          this.create.sysmanager = this.$cookies.get('managerid');
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 获取银行帐户 **/
    getAccount() {
      var resource = this.$resource(this.GLOBAL.domain + "Account/index");
      resource.query({ act: 'lists', isdeposit: 1, isnopay: 1, token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.accountLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 获取打印设置信息 **/
    getPrintdesc() {
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.query({ act: 'getprintinfo', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.printdesc = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 获取品牌 **/
    getBrand() {
      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 获取销售员名称 **/
    getClerkName(id) {
      var resource = this.$resource(this.GLOBAL.domain + "Clerk/index");
      resource.query({ act: 'getname', id: id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.clerkName = res.data.Message;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 获取顾客名称 **/
    getCustomerName(id) {
      if (id != '' && id != null) {
        var resource = this.$resource(this.GLOBAL.domain + "Customer/index");
        resource.query({ act: 'getname', id: id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.customerName = res.data.Message;
          }
        }).catch((res) => {
          //this.$message.error(this.GLOBAL.errortext);
        });
      }
    },

    // 根据打印类型打印销售单***************************************
    printByType(type, checkList) {
      this.currentPrintType = type

      let tableData = []
      this.$refs.sortingBox.forEach(ref => {
        tableData = [...tableData, ...ref.getTableData()]
      })
      this.printorderdetail.goods = tableData
      if (type == '1') {
        // 按照当前排序打印
        // 获取所有列表的tableData，赋值给rintorderdetail.goods
        // this.createnoSave()

        // 每页rollpage条
        const pageArray = []
        this.prpage.forEach((item, index) => {
          // 根据每页rollpage条和index的关系,算出每页的item.num的统计数量
          let totalNum = 0
          // 假设index + 1 是第一页，每页rollpage = 5，那么统计index 0 到index 4的所有数量，以此类推
          for (let i = index * this.rollpage; i < (index + 1) * this.rollpage; i++) {
            if (this.printorderdetail.goods[i]) {
              totalNum += parseInt(this.printorderdetail.goods[i].num)
            }
          }

          pageArray.push({
            ...item,
            totalNum
          })

        })

        this.$set(this, 'prpage', pageArray)

      }
      if (type == '2') {
        // 按照分拣箱顺序打印
        // 根据tableData中的box进行分类
        let splitTableData = [];
        tableData.forEach(item => {
          // 处理分拣箱数据
          item.box.forEach(box => {
            const newItem = { ...item };
            newItem.num = box.box_volume;

            // 根据分拣箱的数量统计 小计金额
            newItem.newTotal = parseFloat(newItem.dis_sell * newItem.num).toFixed(2);

            newItem.boxName = String(box.box_name);
            newItem.id = `${item.id}${box.box_name}`;
            delete newItem.box; // 移除原始的 box 字段
            splitTableData.push(newItem);
          });

          // 处理剩余未分配到箱子的数据
          if (parseInt(item.surplus_num) > 0) {
            const surplusItem = { ...item };
            surplusItem.num = parseInt(item.surplus_num);

            // 根据分拣箱的数量统计 小计金额
            surplusItem.newTotal = parseFloat(surplusItem.dis_sell * surplusItem.num).toFixed(2);

            surplusItem.boxName = "未分配";
            surplusItem.id = `${item.id}未分配`;
            delete surplusItem.box; // 移除原始的 box 字段
            splitTableData.push(surplusItem);
          }
        });

        // 对数据进行排序
        splitTableData.sort((a, b) => {
          if (a.boxName === "未分配") return 1;
          if (b.boxName === "未分配") return -1;
          return parseInt(a.boxName, 10) - parseInt(b.boxName, 10);
        });
        this.printorderdetail.goods = splitTableData
        const uniqueBoxNames = new Set(splitTableData.map(item => item.boxName));
        let pageArray = Array.from(uniqueBoxNames).map((boxName, index) => {
          // 统计出这个分拣箱名称的所有商品的数量
          let totalNum = splitTableData.filter(item => item.boxName === boxName).reduce((acc, item) => acc + item.num, 0);


          return {
            id: index + 1,
            boxName: boxName,
            totalNum: totalNum
          }
        });
        this.$set(this, 'prpage', pageArray)
      }
      if (type == '3') {

        // 打印选中的分拣箱
        let splitTableData = []
        tableData.forEach(item => {
          // 处理分拣箱数据
          item.box.forEach(box => {
            const strName = box.box_name + ''
            if (checkList.includes(strName)) {
              const newItem = { ...item };
              newItem.num = box.box_volume;
              newItem.boxName = String(box.box_name); // 确保箱号名称为字符串
              newItem.id = `${item.id}${box.box_name}`;
              delete newItem.box; // 移除原始的 box 字段
              splitTableData.push(newItem);
            }
          });
        });

        // 对数据进行排序
        splitTableData.sort((a, b) => a.boxName.localeCompare(b.boxName));
        this.printorderdetail.goods = splitTableData


        const uniqueBoxNames = new Set(splitTableData.map(item => item.boxName));
        let pageArray = Array.from(uniqueBoxNames).map((boxName, index) => {
          // 统计出这个分拣箱名称的所有商品的数量
          let totalNum = splitTableData.filter(item => item.boxName === boxName).reduce((acc, item) => acc + item.num, 0);

          return ({
            id: index + 1,
            boxName: boxName,
            totalNum: totalNum
          })
        });
        this.$set(this, 'prpage', pageArray)
      }

      this.createnoSave()

    },
    showPrintTypeDialogFn() {
      this.saveBoxData()
      let boxArr = []
      let isPass = true
      this.$refs.sortingBox.forEach(ref => {
        if (ref.inspection()) {
          boxArr = [...boxArr, ...ref.getBoxNames()]
        } else {
          isPass = false
          return
        }
      })
      if (!isPass) {
        return
      }
      this.showPrintTypeDialog = true
      // 获取所有分拣箱，并且去重
      this.$nextTick(() => {
        const checkList = [...new Set(boxArr)]
        this.$refs.printTypeRef.setCheckList(checkList)
      })
    },
    getPayableAmount(pageNum, pageSize) {
      // pageNum代表第几页，pageSize代表每页显示数量，根据这两个值，判断出当前页的newTotal字段或者题total的累计是多少（优先获取newTotal，没有就取total）
      let totalNum = 0
      this.printorderdetail.goods.forEach((item, index) => {
        // 获取当前页的newTotal字段或者题total的累计是多少（优先获取newTotal，没有就取total）
        if (index >= (pageNum - 1) * pageSize && index < pageNum * pageSize) {
          if (item.newTotal) {
            totalNum += parseFloat(item.newTotal)
          } else {
            totalNum += parseFloat(item.total)
          }

        }
      })
      return totalNum.toFixed(2)
    },
    getDiscountAmount(pageNum, pageSize) {
      // pageNum代表第几页，pageSize代表每页显示数量，根据这两个值，判断出当前页的num字段乘以sell字段的总价，减去newTotal字段小计
      let totalNum = 0
      this.printorderdetail.goods.forEach((item, index) => {
        // 获取当前页的num字段乘以sell字段的总价，减去newTotal字段小计
        if (index >= (pageNum - 1) * pageSize && index < pageNum * pageSize) {
          if (item.newTotal) {
            totalNum += parseFloat(item.num) * parseFloat(item.sell) - parseFloat(item.newTotal)
          } else {
            totalNum += parseFloat(item.num) * parseFloat(item.sell) - parseFloat(item.total)
          }
        }
      })
      return totalNum.toFixed(2)
    },
    /** 通知后端，订单信息打印次数+1 **/
    createnoSave() {
      this.printorderLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'updateprintnumber', token: this.$cookies.get('token'), id: this.printorderdetail.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printorderLoading = false;
        } else {
          this.createsortorders(this.printorderdetail.id, 'printlocalpage');  //生成相应的拣货单        
        }
      }).catch((res) => {
        this.printorderLoading = false;
      });
    },

    /** 打印当前页面 **/
    printlocalpage() {
      this.showSortingBox = false
      this.$nextTick(() => {
        setTimeout(() => {
          //设置打印完成后回调页面
          this.$cookies.set('returnurlids', 'Sellorder');
          //保存当前页面的输入框搜索信息
          var data = {};
          data.orderisselect = this.orderisselect;
          data.order = this.order;
          this.$cookies.set('print_back_data_sellorder', JSON.stringify(data));

          //获取打印信息
          var div_print = document.getElementById('printContent');
          var footerTable = div_print.querySelector('#footerInfo');
          if (footerTable) {
            footerTable.remove(); // 删除底部信息
          }
          var newStr = div_print.innerHTML;
          document.body.innerHTML = newStr;
          window.print();
          location.reload();
        }, 0);
      })

    },


    /** 撤销订单 **/
    cannelorder() {
      this.$confirm('您是否确定将该订单从已审核状态撤销到未审核状态, 是否继续?', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        this.cannelLoading = true;
        var resource = this.$resource(this.url);
        resource.save({ act: 'cannelorder', token: this.$cookies.get('token'), id: this.printorderdetail.id }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.cannelLoading = false;
          } else {
            this.$message.success('撤销订单成功！');
            this.cannelLoading = false;
            this.printerDialog = false;
            this.getOrderlists();
          }
        }).catch((res) => {
          this.cannelLoading = false;
        });
      }).catch(() => {
        this.$message.info('已取消操作!');
      });
    },

    /** 打印页面挂单 **/
    finishorder() {
      this.$confirm('您是否确定完成该订单，将其发货出库, 是否继续?', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        this.finishLoading = true;
        var resource = this.$resource(this.url);
        if (!this.goodsLocationStatus) { this.pick = 0 }
        resource.save({ act: 'finishorder', token: this.$cookies.get('token'), id: this.printorderdetail.id, pick: this.pick }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.finishLoading = false;
          } else {
            this.$message.success('完成订单！');
            this.finishLoading = false;
            this.printerDialog = false;
            this.getOrderlists();
          }
        }).catch((res) => {
          this.finishLoading = false;
        });
      }).catch(() => {
        this.$message.info('已取消操作!');
      });
    },

    /** 获取产品分类 **/
    getCategoryList() {
      var resource = this.$resource(this.GLOBAL.domain + "Product/index");
      resource.query({ act: 'getcatelist', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.categorylist = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 获取打印模板设置 **/
    getprintsmodel(id) {
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.save({ act: 'getmodelsetting', id: 1, sellid: id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.printsmodel = JSON.parse(Base64.decode(res.data.Data));
          console.log(this.printsmodel, '16:37');
          this.rollpage = this.printsmodel.pagevalue < 1 ? 10 : this.printsmodel.pagevalue
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 设置分页设置 **/
    changepage() {
      this.printLoading = true;
      var number = this.rollpage; //系统设置的每页条数
      this.prtotal = this.printorderdetail.goods.length; //总条数
      this.prpage = [];
      this.prollpage = [];

      if (number >= this.prtotal) {
        this.prpage.push({ id: 1 });
        this.prollpage.push({ startpage: 0, endpage: number });
        this.allprintpage = 1;
      } else {
        var tnumber = parseInt(this.prtotal / number);
        var lnumber = this.prtotal % number;
        var index;
        var start;
        var end;
        lnumber > 0 ? tnumber++ : '';
        this.allprintpage = tnumber;

        for (var i = 0; i < tnumber; i++) {
          index = i + 1;
          this.prpage.push({ id: index });
          start = i * number;
          end = index * number - 1;
          this.prollpage.push({ startpage: start, endpage: end });
        }
      }

      this.printLoading = false;
    },

    /** 修改每页条数 **/
    changepagevlaue() {
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.query({ act: 'changepagesize', id: 89, num: this.rollpage, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.changepage();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 获取默认发货仓库id **/
    getdefaultwarehouse() {
      var resource = this.$resource(this.GLOBAL.domain + "Manager/index");
      resource.query({ act: 'getdefaultwarehouse', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.defaultwarehouseid = result.warehouseid;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    //保存订单信息
    saveorder() {
      this.suresellLoading = true;
      this.create.act = 'saveorder';
      var resource = this.$resource(this.url);
      resource.query(this.create).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.suresellLoading = false;
        } else {
          this.$message.success('保存订单信息成功!');
          this.suresellLoading = false;
          this.addandeditsellDialog = false;
          this.getOrderlists();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.suresellLoading = false;
      });
    },

    //确认审核订单
    verifyorder() {
      this.sellverifyLoading = true;
      this.create.act = 'verifyorder';
      var resource = this.$resource(this.url);
      resource.save(this.create).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.sellverifyLoading = false;
        } else {
          this.$message.success('保存订单信息成功!');
          this.sellverifyLoading = false;
          this.addandeditsellDialog = false;
          this.getOrderlists();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.sellverifyLoading = false;
      });
    },

    //删除订单信息
    delorder() {
      this.selldelLoading = true;
      this.create.act = 'delorder';
      var resource = this.$resource(this.url);
      resource.query(this.create).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.selldelLoading = false;
        } else {
          this.$message.success('删除订单信息成功!');
          this.selldelLoading = false;
          this.addandeditsellDialog = false;
          this.getOrderlists();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.selldelLoading = false;
      });
    },


    //展示打印确认页
    showorder(item) {
      //获取打印模板显示标签数据
      this.getprintsmodel(item.id);
      this.getprintdetail(item.id);
    },


    //获取订单打印信息
    getprintdetail(id) {
      this.printerDialog = true;
      this.printLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'getprintinfos', token: this.$cookies.get('token'), id: id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printLoading = false;
        } else {
          this.printorderdetail = JSON.parse(Base64.decode(res.data.Data));
          //对商品进行分页设置
          var number = this.rollpage; //系统设置的每页条数
          this.prtotal = this.printorderdetail.goods.length; //总条数
          this.prpage = [];
          this.prollpage = [];

          if (number >= this.prtotal) {
            this.prpage.push({ id: 1 });
            this.prollpage.push({ startpage: 0, endpage: number });
            this.allprintpage = 1;
          } else {
            var tnumber = parseInt(this.prtotal / number);
            var lnumber = this.prtotal % number;
            var index;
            var start;
            var end;
            lnumber > 0 ? tnumber++ : '';
            this.allprintpage = tnumber;
            for (var i = 0; i < tnumber; i++) {
              index = i + 1;
              this.prpage.push({ id: index });
              start = i * number;
              end = index * number - 1;
              this.prollpage.push({ startpage: start, endpage: end });
            }
          }

          this.printLoading = false;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.printLoading = false;
      });
    },

    //订单列表选择有变动时触发
    handleSelectionChange(val) {
      var _this = this;
      this.orderselectids = []; //清空获取的订单id
      val.forEach(function (item, i) { _this.orderselectids.push(item.id); }); //获取已选中的订单id
      this.orderlists.forEach(function (item, i) { //更新商品的状态
        //查询订单id在选中的数组里是否存在
        if (_this.orderselectids.indexOf(item.id) != -1) {
          _this.orderlistsstatus[i] = 1;
        } else {
          _this.orderlistsstatus[i] = 0;
        }

      });

    },

    //单行点击触发
    selectorder(row, event) {
      if (event.target.tagName === 'BUTTON' || event.target.parentElement.tagName === 'BUTTON') {
        return;
      }

      var _this = this;
      var number = this.orderselectids.indexOf(row.id);
      number == -1 ? this.orderselectids.push(row.id) : this.orderselectids.splice(number, 1);

      this.orderlists.forEach(function (item, i) { //更新商品的状态
        //勾选/取消勾选订单
        if (item.id == row.id) _this.$refs.multipleTable.toggleRowSelection(_this.orderlists[i]);

        //查询订单id在选中的数组里是否存在
        if (_this.orderselectids.indexOf(item.id) != -1) {
          _this.orderlistsstatus[i] = 1;
        } else {
          _this.orderlistsstatus[i] = 0;
        }

      });
    },


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    //批量打印
    printmore() {
      if (this.orderselectids.length == 0) { this.$message.error("请点击订单号左边方框选择需要打印的订单信息"); return false; }
      if (this.orderselectids.length > 10) { this.$message.error("为了打印顺畅，请每次最多不要选择超过10个订单来进行打印"); return false; }
      this.printermoreDialog = true;
      this.printermoreLoading = true;
      this.getmoreprintsmodel(); //获取打印模板信息
    },


    /** 获取打印模板设置 **/
    getmoreprintsmodel() {
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.save({ act: 'getmodelsetting', id: 1, sellid: 0, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.printsmodel = JSON.parse(Base64.decode(res.data.Data));
          this.rollpage = this.printsmodel.pagevalue < 1 ? 10 : this.printsmodel.pagevalue
          this.getmyprintmore(); //获取打印单信息
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    //获取打印单信息
    getmyprintmore() {
      this.printermoreLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'getprintmore', token: this.$cookies.get('token'), orderids: this.orderselectids, rollpage: this.rollpage > 0 ? this.rollpage : 10 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printermoreLoading = false;
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.printmorelists = result.lists; //原订单信息
          this.orderprints = result.show; //展示订单信息
          this.orderprints.forEach(item => {
            item.goods.forEach(good => {
              good.checked = true
            })
          })
          this.printermoreLoading = false;
        }
      }).catch((res) => {
        this.printermoreLoading = false;
      });
    },


    //重新组装打印订单信息
    changeprintorders() {
      this.printermoreLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changeprintmore', token: this.$cookies.get('token'), baselists: this.printmorelists, rollpage: this.rollpage > 0 ? this.rollpage : 10 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printermoreLoading = false;
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.printmorelists = result.lists; //原订单信息
          this.orderprints = result.show; //展示订单信息
          this.printermoreLoading = false;
        }
      }).catch((res) => {
        this.printermoreLoading = false;
      });
    },


    //批量打印订单
    goprintmore() {
      this.$nextTick(() => {
        this.createsortorders(this.orderselectids.join(","), 'printmoregoods');  //生成相应的拣货单  
      })
    },


    //生成拣货单信息
    createsortorders(ids, type) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'addsortingorders', token: this.$cookies.get('token'), sellids: ids }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          if (type == 'printlocalpage') this.printlocalpage(); //单个订单打印
          if (type == 'printmoregoods') this.printmoregoods(); //多个订单批量打印

        }
      }).catch((res) => {

      });
    },

    //多个订单批量打印
    printmoregoods() {
      this.printorderLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changemoreorderprintnumber', token: this.$cookies.get('token'), ids: this.orderselectids }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printorderLoading = false;
        } else {
          //保存当前页面的输入框搜索信息
          var data = {};
          data.orderisselect = this.orderisselect;
          data.order = this.order;
          this.$cookies.set('print_back_data_sellorder', JSON.stringify(data));

          //设置打印信息
          this.printorderLoading = false;
          var div_print = document.getElementById('printmoreContent');
          var newStr = div_print.innerHTML;
          var oldStr = document.body.innerHTML;
          document.body.innerHTML = newStr;
          window.print();
          document.body.innerHTML = oldStr;
          location.reload();
        }
      }).catch((res) => {
        this.printorderLoading = false;
      });
    },



    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    //撤销完成销售订单
    cannelfinish(item) {
      this.$confirm('您是否确定将该订单从已完成的状态撤销到已审核的状态进行复审, 是否继续?', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        this.cannelfinishLoading = true;
        var resource = this.$resource(this.url);
        resource.save({ act: 'cannelfinishorder', token: this.$cookies.get('token'), id: this.printorderdetail.id }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.cannelfinishLoading = false;
          } else {
            this.$message.success('撤销订单成功！');
            this.cannelfinishLoading = false;
            this.printerDialog = false;
            this.getOrderlists();
          }
        }).catch((res) => {
          this.cannelfinishLoading = false;
        });
      }).catch(() => {
        this.$message.info('已取消操作!');
      });
    },


    /** 将订单数据提交至金蝶 **/
    kingdeesellsubmit(item) {
      this.$confirm('警告：操作前请确认该订单是否已完结无需修改，数据一经提交至金蝶成功不可撤销', '提示', { type: 'warning' }).then(() => {
        var resource = this.$resource(this.url);
        resource.query({ act: 'kingdeesubmit', orderid: item.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.getOrderlists();
            this.$message.success('订单数据提交到金蝶成功');
          }
        }).catch((res) => {

        });

      }).catch(() => {

      });
    },


    /** 打印电子面单 **/
    shippingbirldprint() {
      this.$emit('listenchild', { name: '快递鸟打印电子面单', url: 'sellshippingbirld', data: { sellid: 0 } });
    },


    /** 打印单个电子面单 **/
    shippingbirldsingleprint(item) {
      // 新业务==========
      this.$refs.printerExpressRef.openDialog([item])


      // 旧逻辑===================
      // var ids = [];
      // ids.push(item.id);

      // var resource = this.$resource(this.url);
      // resource.save({ act: 'addsortingorders', token: this.$cookies.get('token'), sellids: ids.join(',') }).then((res) => {
      //   if (res.data.Result > 0) {
      //     if (res.data.Result == '70001') this.$router.push('/login')
      //     this.$message.error(res.data.Message);
      //   } else {
      //     var result = JSON.parse(Base64.decode(res.data.Data));
      //     this.$emit('listenchild', { name: '二次分拣', url: 'sellprint', data: { sortorderid: result.id } });
      //   }
      // }).catch((res) => {

      // });
    },


    /** 查看快递信息 **/
    lookshippings(item) {
      this.myorderid = item.id;
      this.myordertype = 'sell';
      this.myshippingDialog = true;
    },
    closemyshippingDialog() {
      this.myorderid = '';
      this.myshippingDialog = false;
    },
    closemyshipping() {
      this.myorderid = '';
      this.myshippingDialog = false;
    },


    /** 获取打印设置信息 **/
    settingprints(item) {
      this.printsettingDialog = true;
      var _this = this;
      setTimeout(function () {
        _this.printclass['margin-right'] = '0%';
      }, 200);

      this.printmadequery.loading = true;
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.save({ act: 'getsellprints', token: this.$cookies.get('token'), id: item.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printmadequery.loading = false;
        } else {
          this.printmadequery.id = item.id;
          this.printmadequery.customername = item.customerName;
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.printmadequery.data = result;
          this.printmadequery.loading = false;
        }
      }).catch((res) => {
        this.printmadequery.loading = false;
      });
    },


    /** 保存打印设置信息 **/
    saveprintmade() {
      var _this = this;
      var data = [];
      this.printmadequery.data.forEach(function (item, i) {
        data.push(item);
      });
      data = JSON.stringify(data);
      this.printmadequery.loading = true;
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.save({ act: 'savesellprints', token: this.$cookies.get('token'), id: this.printmadequery.id, data: data }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printmadequery.loading = false;
        } else {
          this.printmadequery.loading = false;
          //关闭窗口
          this.closeprinters();
          //刷新打印数据模板信息
          this.showorder({ id: this.printmadequery.id });
        }
      }).catch((res) => {
        this.printmadequery.loading = false;
      });
    },


    /** 关闭打印设置窗口 **/
    closeprinters() {
      this.printclass['margin-right'] = '-20%';
      var _this = this;
      setTimeout(function () {
        _this.printsettingDialog = false;
      }, 500);
    },
    checkLocationStatus() {
      const goodsLocationStatus = localStorage.getItem("storageLocationStatus") || ''
      if (goodsLocationStatus == "true") {
        this.goodsLocationStatus = true
      } else {
        this.goodsLocationStatus = false
      }
    },
    exportorder() {
      // ***************
      // console.log(this.printorderdetail, '导出打印订单')
        const url = this.GLOBAL.domain + `Sell/index?token=${this.$cookies.get('token')}&act=export_sell_info&id=${this.printorderdetail.id}`
        window.open(url, '_blank')
    }

  }
}
</script>
<style type="text/css">
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 3% 1%
}

.titlelists {
  float: left;
  width: 100%;
  padding: 0;
  margin: 0
}

.titlelists li {
  float: left;
  width: 30%;
  font-size: 13px;
  list-style-type: none;
  padding-right: 30px;
}

.top1 td {
  padding-top: 2px;
  font-size: 13px
}

.top2 td {
  padding-top: 2px;
  font-size: 13px;
}

.top1 td span {
  font-size: 13px
}

.top2 td span {
  font-size: 13px
}

.sureprint {
  float: right;
  margin-right: 15.5%
}

.printsetting {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10000;
  overflow: hidden;
  transition: .3s all;
  background: rgba(0, 0, 0, 0.6)
}

.printsetting .printmain {
  width: 20%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background: #dddddd;
  border-radius: 15px 0 0 15px;
  border-left: 1px solid #dddddd;
  overflow-y: scroll;
  box-shadow: -2px 0 20px #000000;
  transition: .5s all;
}

.printsetting .printmain::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.printin {
  width: 90%;
  height: 96%;
  margin: 2% 0 0 5%;
  background: #dddddd
}

.printin .el-form-item__label {
  font-size: 13px
}

.contactcontent td {
  line-height: 21px;
}

.cctname {
  overflow: hidden;
  height: 21px;
}

.print-sell {
  width: 100%;
  text-align: right
}

.print-sell-page {
  border-radius: 5px;
  border: 1px solid rgb(192, 196, 204);
  background-color: #fff;
  color: #606266;
  width: 25px;
  height: 30px;
  line-height: 40px;
  padding: 0 15px;
  margin-bottom: 20px
}

.print-sell-page-show {
  float: right
}

.print-sell-page-title {
  font-size: 13px;
  padding-bottom: 2px;
  margin-bottom: 0
}

.print-sell-page-table {
  border-collapse: collapse;
  font-size: 13px;
  border-color: #333333
}

.sell-type-main {
  display: flex;
  justify-content: left;
  align-items: center;
}

.sell-type-icon {
  width: 16px;
  height: 16px;
  margin-left: 10px;
  overflow: hidden;
}

.sell-type-icon img {
  float: left;
  width: 100%
}

@media print {
  @page {
    margin: 0;
  }

  body {
    margin: 1cm;
  }

  .pageBreak {
    page-break-after: always;
  }

  .noPrint {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/Sellorder.vue